import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { useBuzzoolaPostViewAnalytics } from '../../hooks/useBuzzoolaPostViewAnalytics';
import { useConstant } from '../../hooks/useConstant';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { ensureBuzzoolaApiAvailable } from '../../utils/ensureBuzzoolaApiAvailable';
import { getCompleteSizes } from '../../utils/getCompleteSizes';
import styles from './BuzzoolaBanner.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const BuzzoolaBanner = _ref => {
  let {
    analyticsData,
    galleryPosition,
    onClick,
    onDestroy,
    onError,
    onFetch,
    onInternalError,
    onImpression,
    onNoad,
    onReady,
    onView,
    onView1,
    onView2,
    placementId,
    position,
    sizes,
    thirdPartyRequestParams
  } = _ref;
  const elementRef = useRef(null);
  const traceId = useConstant(() => uuid());
  const completeSizes = useConstant(() => getCompleteSizes(sizes));
  const analytics = useBuzzoolaPostViewAnalytics({
    callbacks: {
      onClick,
      onError,
      onInternalError,
      onLoad: onReady,
      onStub: onNoad,
      onView,
      onView1,
      onView2
    },
    elementRef,
    initialBuzzoolaAnalyticsPayload: _objectSpread(_objectSpread({}, analyticsData), {}, {
      galleryPosition,
      placementId,
      position
    }),
    traceId
  });
  useIsomorphicLayoutEffect(() => {
    ensureBuzzoolaApiAvailable(analytics.onInternalError);
  }, []);

  /**
   * @description Хук для отслеживания видимости баннера на странице, за один экран до видимости баннера нужно зарегистрировать его в buzzoola
   */
  useIntersectionObserver({
    elementRef,
    initSubscribeAvailable: true,
    observerOptions: () => ({
      rootMargin: "".concat(window.innerHeight, "px ").concat(window.innerWidth, "px ").concat(window.innerHeight, "px ").concat(window.innerWidth, "px"),
      threshold: 0
    }),
    onInViewport(_ref2) {
      var _window, _window$buzzoolaAdUni;
      let {
        subscribeState: {
          setSubscribeUnavailable
        },
        element
      } = _ref2;
      const adUnit = {
        onClick: analytics.onClick,
        onDestroy,
        onError: analytics.onError,
        onFetch,
        onImpression,
        onNoad: analytics.onStub,
        onReady: analytics.onLoad,
        placementHash: traceId,
        placementId,
        slot: element,
        thirdPartyRequestParams
      };
      ((_window$buzzoolaAdUni = (_window = window).buzzoolaAdUnits) !== null && _window$buzzoolaAdUni !== void 0 ? _window$buzzoolaAdUni : _window.buzzoolaAdUnits = []).push(adUnit);
      setSubscribeUnavailable();
    }
  });
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.container, " buzzplayer-").concat(placementId),
    ref: elementRef,
    style: completeSizes
  });
};